import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import AllocationKeys from 'components_new/pages/settings/AllocationKeys'
import ApiKeys from 'components_new/pages/settings/Apikeys'
import Authentication from 'components_new/pages/settings/Authentication'
import Companies from 'components_new/pages/settings/Companies'
import Configuration from 'components_new/pages/settings/Configuration'
import Customization from 'components_new/pages/settings/Customization'
import DataAccess from 'components_new/pages/settings/DataAccess'
import Economy from 'components_new/pages/settings/Economy'
import Entities from 'components_new/pages/Entities'
import Integrations from 'components_new/pages/settings/Integrations'
import IntegrationDetail from 'components_new/pages/settings/Integrations/FortnoxDetail'
import McpTokens from 'components_new/pages/settings/McpTokens'
import Users from 'components_new/pages/settings/Users'

import { useAllowAccessApiKeys } from 'redux/hooks/Permissions'
import { useIsAuthenticated } from 'redux/hooks/SignedInAccount'

import AuthRoute from './AuthRoute'
import Entity from 'components_new/pages/Entity'
import SettingsLanding from 'components_new/pages/SettingsLanding'

const Routes = () => {
  const isAuthenticated = useIsAuthenticated()
  const allowAccessApiKeys = useAllowAccessApiKeys()

  return (
    <Switch>
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <Users />}
        path={'/settings/users'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <DataAccess />}
        path={'/settings/data-access'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <Companies />}
        path={'/settings/companies'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <Configuration />}
        path={'/settings/config'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <Integrations />}
        path={'/settings/integrations'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <IntegrationDetail />}
        path={'/settings/integrations/:type'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <AllocationKeys />}
        path={'/settings/allocation-keys'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <Economy />}
        path={'/settings/economy'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <Customization />}
        path={'/settings/customization'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated && allowAccessApiKeys}
        Component={() => <ApiKeys />}
        path={'/settings/api-keys'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <Authentication />}
        path={'/settings/authentication'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <McpTokens />}
        path={'/settings/mcp'}
        exact
      />
      <AuthRoute
        isAuthenticated={isAuthenticated}
        Component={() => <SettingsLanding />}
        path={'/settings'}
        exact
      />
      <AuthRoute
        Component={() => <Entity />}
        isAuthenticated={isAuthenticated}
        path={'/entities/:id'}
      />
      <AuthRoute
        Component={() => <Entities />}
        isAuthenticated={isAuthenticated}
        path={'/entities'}
        exact
      />
      <Route path={'/admin'}>
        <Redirect to="/settings" />
      </Route>
      <Route path={'/admin/*'}>
        <Redirect to="/settings" />
      </Route>
      <Route path={'/settings/*'}>
        <Redirect to="/settings" />
      </Route>
    </Switch>
  )
}

export default Routes
